import React, {Component} from 'react';
import {connect} from 'react-redux';
import Scrollchor from 'react-scrollchor';
import SideNavPublishButton from '../body/visibility/SideNavPublishButton';
import * as Buttons from '../../elements/ui/buttons';
import {MessageModal} from '../../elements/ui';
import * as networkingActions from '../../../../../../actions/networking/networking';
import {PublishWarningError} from '../../elements/ui';

class SideNav extends Component {
    constructor() {
        super();
        this.state = {
            isOpen: false,
            isThanks: false,
            isWarningModalOpen: false,
        }
    }

    handleSendMessage(message, recipientId) {
        const { dispatch } = this.props, personId = localStorage.getItem('person_id');
        this.setState({isThanks: true});
        return dispatch( networkingActions.createConversation(message, recipientId, personId) );
    };

    handleThanks() {
        this.setState({isThanks: true})
    };

    handleClose() {
        this.setState({isThanks: false});
        this.setState({isOpen: false});
    };

    render() {
        const animateSettings = {offset: -160, duration: 600},
                { visibility, guestMode, summary, experience,
                    endorsements, education, certificates, press, awards, publications, name, memberId, forms } = this.props,
                        noDataAchievements = press.noData && awards.noData && publications.noData,
                            {isOpen, isThanks, isWarningModalOpen} = this.state;
            return (
                <React.Fragment>
                    { !guestMode && !forms.editing && <SideNavPublishButton
                        { ...visibility }
                        summary={summary}
                        experience={experience}
                        openWarningModal={ () => this.setState({isWarningModalOpen: true}) }
                    />
                    }
                    { guestMode && <Buttons.SideNavContactButton handleOnClick={ () => this.setState({isOpen: true})}/> }
                    { isOpen  &&  !!memberId && <MessageModal name={name}
                                            isOpen={isOpen}
                                            isThanks={isThanks}
                                            onClose={ () => this.handleClose() }
                                            onSave={ (message) => { this.handleSendMessage( message, memberId ) } }/>
                    }
                    { isWarningModalOpen && <PublishWarningError
                        cancelWarningModal={ () => this.setState({isWarningModalOpen: false}) }
                    />
                    }
                </React.Fragment>
            )
    }
}

export default connect()(SideNav);



// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/header/SideNav.js